import classnames from 'classnames/bind'

// styles
import styles from './style.module.scss'

interface IDots {
  activeIndex: number
  dataLength: number
}
const cx = classnames.bind(styles)

const Dots = ({ activeIndex, dataLength }: IDots) => {
  return (
    <div className={cx('dots')}>
      {Array.from(Array(dataLength)).map((_, index) => {
        return <div key={index} className={cx('dots-item', { active: activeIndex === index })} />
      })}
    </div>
  )
}

export default Dots
